<template>
  <v-card flat :loading="loading" :disabled="loading">
    <v-list dense nav class="menu_dashboard">
      <v-list-item-group color="info">
        <div v-for="(menu, index) in menus" :key="index">
          <v-list-item
            v-if="menu.type === 'single' && menu.permission"
            :disabled="menu.disabled"
            :to="menu.no_action ? '' : { path: menu.path }"
            @click="menu.click_menu ? mudaMenu(menu.click_menu) : ''"
          >
            <v-list-item-icon>
              <v-icon>{{ menu.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ menu.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-group
            v-if="menu.type === 'group' && menu.permission"
            no-action
            :group="menu.path"
            :prepend-icon="menu.icon"
            :disabled="menu.disabled"
          >
            <template v-slot:activator>
              <v-list-item-title>{{ menu.name }}</v-list-item-title>
            </template>
            <div v-for="(child, index) in menu.children" :key="index">
              <v-list-item
                v-if="child.type === 'single'"
                :to="{ path: child.path }"
                :disabled="child.disabled"
              >
                <v-list-item-icon>
                  <v-icon>{{ child.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{ child.name }}</v-list-item-title>
              </v-list-item>
            </div>
          </v-list-group>
        </div>
      </v-list-item-group>
    </v-list>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "MenuDashboardColaborador",

  data() {
    return {
      loading: false,
      menus: null,
    };
  },

  computed: {},

  methods: {
    ...mapActions("Componentes", {
      STORE_getAccess: "getAccess",
    }),

    mudaMenu(menu) {
      this.$store.commit("UPDATE_MENUDINAMICO", menu);
    },
  },

  async mounted() {
    this.loading = true;
    this.menus = [
      {
        type: "single",
        name: "Home",
        path: "/colaborador/home",
        icon: "mdi-home",
        disabled: false,
        permission: true,
      },
      {
        type: "single",
        name: "Clientes",
        path: "/colaborador/clientes",
        icon: "mdi-account-group",
        disabled: false,
        permission: true,
      },
      {
        type: "single",
        name: "Calendário Atividades",
        path: "/colaborador/calendario-atividades",
        icon: "mdi-calendar-question",
        disabled: false,
        permission: true,
      },
      {
        type: "single",
        name: "Calendário Editorial Mídias Sociais",
        path: "/colaborador/midias-sociais/calendario-midias-sociais",
        icon: "mdi-calendar",
        disabled: false,
        permission: true,
      },
      {
        type: "single",
        name: "Atividades",
        path: "/colaborador/atividades",
        icon: "mdi-briefcase-edit-outline",
        disabled: false,
        permission: true,
      },
    ];
    this.loading = false;
  },
};
</script>

<style lang="scss" scoped>
.menu_dashboard ::v-deep .v-list-item {
  padding-top: 3px;
  padding-bottom: 3px;
  margin-bottom: 3px;
}

.menu_dashboard ::v-deep .v-list-item .v-list-item__title {
  font-size: 0.9rem !important;
  font-weight: 500;
  line-height: 1rem;
}
</style>
